import { DataTable } from '../../../../design-system/data-table/data-table';
import { InvoiceEvidenceView } from '../../../../types/entity-types';
import { toPayInvoiceTableColumnsDefinition } from './to-pay-invoice-table-columns-definition';
import { sortEvidencesByEffectiveDueDateOldestToNewest } from './utils/sort-evidences-by-effective-due-date-oldest-to-newest';

type ToPayInvoiceTableProps = {
  evidences: InvoiceEvidenceView[];
  isFetchingDocumentUrl: boolean;
  selectedEvidenceId?: string;
  isEmailConnected: boolean;
  onReviewInvoice: (invoiceId: string) => void;
  onSelectMenuItem: <MenuItemVariant>(payload: { entityId: string; menuItemVariant: MenuItemVariant }) => void;
  onDataSorted: (sortedEvidence: InvoiceEvidenceView[]) => void;
};

export const ToPayInvoiceTable = ({
  evidences,
  isFetchingDocumentUrl,
  selectedEvidenceId,
  isEmailConnected,
  onReviewInvoice,
  onSelectMenuItem,
  onDataSorted,
}: ToPayInvoiceTableProps) => {
  const sortedEvidences = sortEvidencesByEffectiveDueDateOldestToNewest(evidences);

  return (
    <DataTable
      columns={toPayInvoiceTableColumnsDefinition}
      data={sortedEvidences}
      initialSorting={[
        { id: 'dueDate', desc: false },
        { id: 'receivedFrom', desc: false },
        { id: 'invoiceInfo', desc: false },
      ]}
      meta={{
        isFetchingDocumentUrl,
        onReviewInvoice,
        selectedEvidenceId,
        onSelectMenuItem,
        isEmailConnected,
      }}
      onDataSorted={onDataSorted}
    />
  );
};
